<h1 mat-dialog-title>
    {{ title }}
</h1>
